import { render, staticRenderFns } from "./GwFooter.vue?vue&type=template&id=206b9272&scoped=true&"
import script from "./GwFooter.vue?vue&type=script&lang=js&"
export * from "./GwFooter.vue?vue&type=script&lang=js&"
import style0 from "./GwFooter.vue?vue&type=style&index=0&id=206b9272&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206b9272",
  null
  
)

export default component.exports